import { axios } from '~/plugins/axios'

const actions = {
  async fetchWorkloads(_, params) {
    const resp = await axios.get('/api/document-flow/workloads', { params })
    return resp.data
  },

  async exportWorkloads(_, params) {
    return axios.get('/api/document-flow/workloads/export', { params, responseType: 'blob' })
  },

  async createWorkload(_, payload) {
    const resp = await axios.post('/api/document-flow/workloads', payload)
    return resp.data.data
  },

  async updateWorkload(_, { id, data }) {
    const resp = await axios.put(`/api/document-flow/workloads/${id}`, data)
    return resp.data.data
  },

  async deleteWorkload(_, id) {
    const resp = await axios.delete(`/api/document-flow/workloads/${id}`)
    return resp.data
  },

  async createWorkloadPeriod(_, payload) {
    const resp = await axios.post('/api/document-flow/workload-periods', payload)
    return resp.data.data
  },

  async updateWorkloadPeriod(_, { id, data }) {
    const resp = await axios.put(`/api/document-flow/workload-periods/${id}`, data)
    return resp.data.data
  },

  async deleteWorkloadPeriod(_, id) {
    const resp = await axios.delete(`/api/document-flow/workload-periods/${id}`)
    return resp.data
  },
}

export default {
  namespaced: true,
  actions,
}
